import { Controller } from "@hotwired/stimulus"

// Mostra o campo de data fim quando o prazo é final ('true') e o preenche com
// a data padrão (data-valor do alvo `padrao`); senão esconde o campo e usa a
// data sentinela (prazo indeterminado).
export default class extends Controller {
  static targets = ["control", "field", "dataFim", "padrao"]
  static values = { sentinela: { type: String, default: "9999-01-01" } }

  toggle() {
    if (this.controlTarget.value === "true") {
      this.dataFimTarget.value = this.padraoTarget.dataset.valor
      this.fieldTarget.style.display = ""
    } else {
      this.fieldTarget.style.display = "none"
      this.dataFimTarget.value = this.sentinelaValue
    }
  }
}
